import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(3.000000, 3.000000)">
          <g>
            <mask id="bank-account-mask" fill="white">
              <path d="M10.3431458,0.25 C11.6029241,0.25 12.8111052,0.750444992 13.701903,1.64124279 L16.3587572,4.29809704 C17.249555,5.18889484 17.75,6.39707592 17.75,7.65685425 L17.75,16 C17.75,16.9664983 16.9664983,17.75 16,17.75 L2,17.75 C1.03350169,17.75 0.25,16.9664983 0.25,16 L0.25,2 C0.25,1.03350169 1.03350169,0.25 2,0.25 L10.3431458,0.25 Z M10.3431458,1.75 L2,1.75 C1.86192881,1.75 1.75,1.86192881 1.75,2 L1.75,16 C1.75,16.1380712 1.86192881,16.25 2,16.25 L16,16.25 C16.1380712,16.25 16.25,16.1380712 16.25,16 L16.25,7.65685425 C16.25,6.79490066 15.9075903,5.96825044 15.298097,5.35875721 L12.6412428,2.70190296 C12.0317496,2.09240973 11.2050993,1.75 10.3431458,1.75 Z M13.5,10.75 L13.5,12.25 L4,12.25 L4,10.75 L13.5,10.75 Z M10,6.25 L10,7.75 L4,7.75 L4,6.25 L10,6.25 Z" />
            </mask>
            <g mask="url(#bank-account-mask)">
              <g transform="translate(-3.000000, -3.000000)">
                <rect fill="currentColor" x="0" y="0" width="24" height="24" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
